<template>
  <div class="jump">
    <!-- <p style="24px">
      正在跳转到支付页面，请稍候~
    </p> -->
    <img src="@/assets/images/loading.gif" alt="" />
  </div>
</template>

<script>
import wayCode from '@/utils/wayCode';
import config from "@/config";

// 分发器页面，  用户扫码后进入的第一个页面：
// 判断是否存在channelUserId, 如果存在则直接跳到 对应的支付页面，如果不存在则重定向到对应的页面。
export default {
  components: {
  },
  mounted() {
    console.log("正在跳转", this.$route.params, this.$route.query)

    const payWay = wayCode.getPayWay();
    
    // AlipayPlus 不需要 OAuth 授权，直接进收银台
    if (payWay && payWay.wayCode === 'ALIPAYPLUS_JSAPI') {
      this.$router.push({ name: payWay.routeName });
      return;
    }

    if (payWay && payWay.wayCode === 'WX_JSAPI') {
      // 没有进行微信登录认证，需要进行微信授权认证,在进行微信授权时候有一点需要注意，提供给微信的授权回调URL只能带一个参数
      // process.env.WX_APP_ID 微信公众号的appid 保存在config 配置文件
      const callbackPath = this.$router.resolve({ name: 'Oauth2Callback', params: { sid: config.cacheToken } }).href
      const url = encodeURIComponent(`${window.location.origin}${callbackPath}`)
      const authorizeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.wxAppId + '&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
      location.replace(authorizeUrl)
      // this.$router.push({ name: payWay.routeName });
      return;
    }
  }
}
</script>
<style lang="css" scoped>
  .jump {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
